import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import MainHeader from './components/header/Header';
import Login from './components/Login';

import ProtectedRoute from './components/ProtectedRoute';
import Home from './components/Home/Home';
import Training from './components/Pages/services/training';
import Evaluate from './components/Pages/services/evaluate';
import TrainingKits from './components/Pages/services/training-kits';

import SpinnerNew from './components/LoadingSpinner';
import Profile from './components/Profile/Profile';
import TrainingPlan from './components/Trainingplan/training-plan';
import Planpage2 from './components/Trainingplan/Planpage';

import './App.css';
import 'animate.css/animate.min.css';
import ContactUs from './components/ContactUs/ContactUs';
import PaymentSuccess from './components/userView/Paymentsucess';
import Podcasts from './components/Pages/podcasts';
import PodcastDetails from './components/Pages/PodcastDetails';
import Seminars from './components/Pages/seminars';
import SeminarsDetails from './components/Pages/SeminarDetails';
// import LastestNews from './components/Home/LatestNews';
import AllNews from './components/Home/news';
import NewsDetails from './components/Home/news-details';
import BlogDetails from './components/Home/blog-details';

import AllBlogs from './components/Home/Allblogs';
import Dependencies from './components/Pages/dependencies';
import Clientservice from './components/Pages/ClientSearvice';
import TrainingPrograms from './components/Pages/DependencyPrograms';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import NotFound from './components/PrivacyPolicy/NotFound';
import Footer from './components/footer/Footer';

import FloatingSocial from './components/FloatingSocial/FloatingSocial';

import ContractualCoursesForm from './components/userView/Contractural';
import AboutIvory from './components/Home/Ivory/AboutIvory';
import Forget from './Forget';
import OTPVerification from './Reciveopt';
import ResetPassword from './Truepassword';
import CheckCertificate from './components/Pages/CertificateVerification';
import TrainingCourses from './components/Pages/training-courses';
import TrainingCourseDetails from './components/TrainingCourses/content/training-course-details';
import Payment from './components/Pages/Payment';
import PaymentLogin from './components/TrainingCourses/payment/PaymentLogin';
import PaymentWay from './components/TrainingCourses/payment/PaymentWay';
import PaymentCard from './components/TrainingCourses/payment/PaymentCard';
import { UserPaymentProvider } from './store/UserPayment';
import EditProfile from './components/Profile/edit-profile';
import { UserDataProvider } from './store/UserData';
import Coaching from './components/Pages/services/coaching';
import PaymentFailed from './components/userView/PaymentFailed';

import LearningSolutions from './components/Pages/services/learning-solutions';
import InstitutePlans from './components/Pages/institute-Plans/institute-Plans';
import OffersDetails from './components/Pages/services/offers-details';
import Offers from './components/Pages/services/offers';

import Achievements from './components/achievements/achievements';
import AchievementDetails from './components/achievements/achievement-details';
import Consulting from './components/Pages/services/consulting';
import ThirdSector from './components/Pages/services/third-sector';
import SubjectCourses from './components/Trainingplan/SubjectCourses';
import ContractualCourses from './components/Contractual/Contractualcours';
import LeadershipSoltions from './components/Pages/services/leadership-solutions';
import Platforms from './components/Pages/services/platforms';
import { useTranslation } from 'react-i18next';
import { useLanguage } from './store/language-context';
import CMI from './components/cmi/cmi';
import LevelOne from './components/Pages/services/level-1';
import AllAchievements from './components/achievements/all-achievements';
import AllBlog from './components/achievements/all-blogs';
import AllNew from './components/achievements/all-news';
import Diploma from './components/new-pages/diploma';
import LevelThree from './components/Pages/services/level-3';
import LevelTwo from './components/Pages/services/level-2';
import LevelFour from './components/Pages/services/level-4';
import Event from './components/Events/Event';
const PageTitles = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { lang } = useLanguage();
  // for titles 
  useEffect(() => {
    const titles = {
      "/": `${t('routes.home')} | ${t('ivory')}`,
      "/about": `${t('routes.about')} | ${t('ivory')}`,
      "/about-ivory": `${t('routes.about-ivory')} | ${t('ivory')}`,
      "/contactus": `${t('routes.contact-us')} | ${t('ivory')}`,
      "/login": `${t('routes.login')} | ${t('ivory')}`,
      "/register": `${t('routes.register')} | ${t('ivory')}`,
      "/profile": `${t('routes.profile')} | ${t('ivory')}`,
      "/profile/edit": `${t('routes.profile-edit')} | ${t('ivory')}`,
      "/privacy": `${t('routes.privacy-policy')} | ${t('ivory')}`,
      "/dashboard": `${t('routes.dashboard')} | ${t('ivory')}`,

      "/podcasts": `${t('routes.podcasts')} | ${t('ivory')}`,
      "/podcasts/:id": `${t('routes.podcast-details')} | ${t('ivory')}`,

      "/training-courses": `${t('routes.training-courses')} | ${t('ivory')}`,
      "/training-courses/:id": `${t('routes.training-courses-details')} | ${t('ivory')}`,
      "/courses/course-details/:id": `${t('routes.course-details')} | ${t('ivory')}`,
      "/courses/CheckoutPage": `${t('routes.checkout')} | ${t('ivory')}`,

      "/training-plan": `${t('routes.training-plan')} | ${t('ivory')}`,
      "/training-plan/:id": `${t('routes.training-plan-single')} | ${t('ivory')}`,
      "/training-plan/details/:id": `${t('routes.training-plan-details')} | ${t('ivory')}`,

      "/all-blogs": `${t('routes.all-blogs')} | ${t('ivory')}`,
      "/blogs": `${t('routes.blogs')} | ${t('ivory')}`,
      "/blogs/:id": `${t('routes.blog-details')} | ${t('ivory')}`,

      "/news": `${t('routes.news')} | ${t('ivory')}`,
      "/news/:id": `${t('routes.news-details')} | ${t('ivory')}`,

      "/dependencies": `${t('routes.accreditations')} | ${t('ivory')}`,
      "/dependencies/:id": `${t('routes.dependency-details')} | ${t('ivory')}`,

      "/institute-plans": `${t('routes.institute-plans')} | ${t('ivory')}`,

      "/offers": `${t('routes.offers')} | ${t('ivory')}`,
      "/offers/:id": `${t('routes.offer-details')} | ${t('ivory')}`,

      "/achievements": `${t('routes.achievements')} | ${t('ivory')}`,
      "/achievements/:id": `${t('routes.achievement-details')} | ${t('ivory')}`,

      "/subject-courses": `${t('routes.subject-courses')} | ${t('ivory')}`,
      "/contractual-courses": `${t('routes.contractual-courses')} | ${t('ivory')}`,
      "/contractual": `${t('routes.contractual')} | ${t('ivory')}`,
      "/all-courses": `${t('routes.all-courses')} | ${t('ivory')}`,

      "/courses/payment": `${t('routes.payment')} | ${t('ivory')}`,
      "/courses/payment/failed": `${t('routes.payment-failed')} | ${t('ivory')}`,
      "/courses/payment/success": `${t('routes.payment-success')} | ${t('ivory')}`,
      "/courses/payment/pending": `${t('routes.payment-pending')} | ${t('ivory')}`,
      "/payment/way": `${t('routes.payment-way')} | ${t('ivory')}`,
      "/payment/card": `${t('routes.payment-card')} | ${t('ivory')}`,

      "/traning-courses/:id/payment/way": `${t('routes.payment-way')} | ${t('routes.training-courses')}`,
      "/traning-courses/:id/payment/card": `${t('routes.payment-card')} | ${t('routes.training-courses')}`,
      "/offers/:id/payment/way": `${t('routes.payment-way')} | ${t('routes.offers')}`,
      "/offers/:id/payment/card": `${t('routes.payment-card')} | ${t('routes.offers')}`,

      "/services": `${t('routes.services')} | ${t('ivory')}`,
      "/services/training": `${t('routes.training')} | ${t('routes.services')}`,
      "/services/evaluate": `${t('routes.evaluations')} | ${t('routes.services')}`,
      "/services/coaching": `${t('routes.coaching')} | ${t('routes.services')}`,
      "/services/platforms": `${t('routes.platforms')} | ${t('routes.services')}`,
      "/services/training-kits": `${t('routes.training-kits')} | ${t('routes.services')}`,
      "/services/consulting": `${t('routes.consulting')} | ${t('routes.services')}`,
      "/services/learning-solutions": `${t('routes.learning-solutions')} | ${t('routes.services')}`,
      "/services/sector": `${t('routes.third-sector')} | ${t('routes.services')}`,
      "/services/leadership-solutions": `${t('routes.leadership-solutions')} | ${t('routes.services')}`,

      "/seminars": `${t('routes.seminars')} | ${t('ivory')}`,
      "/seminars/:id": `${t('routes.seminar-details')} | ${t('ivory')}`,

      "/clientservice": `${t('routes.client-service')} | ${t('ivory')}`,
      "/certificate-verification": `${t('routes.certificate-verification')} | ${t('ivory')}`,
      "/cmi": `${t('routes.cmi')} | ${t('ivory')}`,
      "/diploma": `${t('routes.diploma')} | ${t('ivory')}`,
      "/otp-code": `${t('routes.otp')} | ${t('ivory')}`,
      "/reset-password": `${t('routes.reset-password')} | ${t('ivory')}`
    };

    // Handle dynamic routes
    const path = Object.keys(titles).find((key) =>
      new RegExp(`^${key.replace(/:\w+/g, ".*")}$`).test(location.pathname)
    );

    // Only update title and scroll if we're actually changing pages
    if (document.title !== (titles[path] || "ايفوري | Ivory")) {
      document.title = titles[path] || "ايفوري | Ivory";
      // Only scroll if this is a page navigation, not a tab switch
      if (document.visibilityState === 'visible') {
        window.scrollTo({
          top: 0,
          behavior: 'instant'
        });
      }
    }
  }, [location, lang, t]);

  return null;
};

const App = () => {
  const [isFlash, setIsFlash] = useState(true);

  setTimeout(() => {
    setIsFlash(false);
  }, 40000);
  return (
    <div>
      <Router>
        <PageTitles />
        {isFlash && <SpinnerNew isFlash={isFlash} />}
        <HeaderWrapper
          setIsFlash={setIsFlash}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutIvory />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forget" element={<Forget />} />
          <Route path="/otp-code" element={<OTPVerification />} />
          <Route path="/reset-password" element={
            <ProtectedRoute component={ResetPassword} />
          } />

          <Route path="/profile" element={
            <UserDataProvider>
              <ProtectedRoute component={Profile} />
            </UserDataProvider>
          } />
          <Route path="/profile/edit" element={
            <UserDataProvider>
              <ProtectedRoute component={EditProfile} />
            </UserDataProvider>
          } />
          <Route path="/institute-plans" element={<InstitutePlans />} />

          <Route path="/services/training" element={<Training />} />
          <Route path="/services/evaluate" element={<Evaluate />} />
          <Route path="/services/training-kits" element={<TrainingKits />} />
          <Route path="/services/coaching" element={<Coaching />} />
          <Route path="/services/learning-solutions" element={<LearningSolutions />} />
          <Route path="/services/consulting" element={<Consulting />} />
          <Route path="/services/platforms" element={<Platforms />} />
          <Route path="/services/sector" element={<ThirdSector />} />

          <Route path="/product/cmi" element={<CMI />} />

          <Route path="/product/leadership-solutions" element={<LeadershipSoltions />} />
          <Route path="/product/leadership-solutions/level-1" element={<LevelOne />} />
          <Route path="/product/leadership-solutions/level-2" element={<LevelTwo />} />
          <Route path="/product/leadership-solutions/level-3" element={<LevelThree />} />
          <Route path="/product/leadership-solutions/level-4" element={<LevelFour />} />
          <Route path="/event/:id" element={<Event />} />


          <Route path="/subject-courses/:id" element={<SubjectCourses />} />

          <Route path="/offers" element={
            <UserPaymentProvider>
              <Offers />
            </UserPaymentProvider>
          } />

          <Route path="/offers/:id" element={
            <UserPaymentProvider>
              <OffersDetails />
            </UserPaymentProvider>
          } />


          <Route
            path="/offers/:id/payment"
            element={
              <UserPaymentProvider>
                <Payment page={'offers'} />
              </UserPaymentProvider>
            }
          >


            <Route index element={<Navigate to="login" />} />
            <Route path="login" element={<PaymentLogin />} />
            <Route path="way" element={<PaymentWay page={'offers'} />} />
            <Route path="card" element={<PaymentCard page={'offers'} whatLinkToGetBox={'offers'} />} />
          </Route>

          <Route path="/training-plan" element={<TrainingPlan />} />
          <Route path="/training-plan/:id" element={<Planpage2 />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/courses/payment/success" element={<PaymentSuccess />} />
          <Route path="/courses/payment/failed" element={<PaymentFailed />} />
          <Route path="/podcasts" element={<Podcasts />} />
          <Route path="/podcasts/:id" element={<PodcastDetails />} />
          <Route path="/seminars" element={<Seminars />} />
          <Route path="/seminars/:id" element={<SeminarsDetails />} />
          <Route path="/news" element={<AllNews />} />
          <Route path="/news/:id" element={<NewsDetails />} />
          <Route path="/blogs/:id" element={<BlogDetails />} />
          <Route path="/blogs" element={<AllBlogs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/contractural" element={<ContractualCourses />} />
          <Route path="/all-achievements" element={<AllAchievements />} />
          <Route path="/all-blogs" element={<AllBlog />} />
          <Route path="/all-news" element={<AllNew />} />

          <Route
            path="/training-courses"
            element={
              <UserPaymentProvider>
                <TrainingCourses />
              </UserPaymentProvider>
            }
          />
          <Route
            path="/training-courses/:id"
            element={
              <UserPaymentProvider>
                <TrainingCourseDetails />
              </UserPaymentProvider>
            }
          />
          <Route
            path="/training-courses/:id/payment"
            element={
              <UserPaymentProvider>
                <Payment page={'training-courses'} />
              </UserPaymentProvider>
            }
          >
            <Route index element={<Navigate to="login" />} />
            <Route path="login" element={<PaymentLogin />} />
            <Route path="way" element={<PaymentWay page={'training-courses'} />} />
            <Route path="card" element={<PaymentCard page={'training-courses'} whatLinkToGetBox={'courses'} />} />
          </Route>

          <Route path='/achievements' element={<Achievements />} />
          <Route path='/achievements/:id' element={<AchievementDetails />} />
          <Route />
          <Route path="/dependencies" element={<Dependencies />} />
          <Route path="/dependencies/:dependencyId" element={<TrainingPrograms />} />
          <Route path="*" element={<NotFound />} />

          <Route path="/clientservice" element={<Clientservice />} />
          <Route path="/certificate-verification" element={<CheckCertificate />} />

          <Route path="/diploma" element={<Diploma />} />
        </Routes>
        <FloatingSocial />
        <ContractualCoursesForm />
        <Footer />
      </Router>
    </div>
  );
};

const HeaderWrapper = ({ setIsFlash }) => {
  const location = useLocation();

  useEffect(() => {
    const hasVisited = localStorage.getItem('visited');
    if (!hasVisited) {
      setIsFlash(true);
      setTimeout(() => {
        setIsFlash(false);
      }, 2700);
      localStorage.setItem('visited', 'true');
    }
  }, [setIsFlash]);

  if (location.pathname === '/login'
    || location.pathname === '/forget'

    || location.pathname === '/otp-code'
    || location.pathname === '/reset-password'
  ) {
    return null;
  }

  return (
    <>
      <MainHeader />
    </>
  );
};


export default App;
